import DnsIcon from '@mui/icons-material/Dns';
import type { ReactNode } from 'react';

export interface MenuItem {
  name: string;
  icon?: ReactNode;
  link?: string;
  items?: MenuItem[];
  features?: string[];
  badge?: string;
  badgeTooltip?: string;
  description?: string;
}

interface MenuItems {
  items: MenuItem[];
  heading: string;
  features?: string[];
}

const menuItems: MenuItems[] = [
  {
    heading: '',
    items: [
      {
        name: 'Records',
        link: '/activity/list',
        icon: DnsIcon
      },
      {
        name: 'Control Centre',
        link: '/settings/control-center'
      }
    ]
  }
];

export const organisationItems = menuItems;

export default menuItems;
